module.exports = __webpack_public_path__ + "static/media/Joe-Lindahl Headshot_1629300684551.0d797cab.jpg";